import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-4 py-4.5 border border-gray-200 shadow sm:rounded-lg h-52 overflow-auto" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-500 mb-4"
}

import { computed, onUnmounted, ref, watch } from "vue"
import { SearchIcon } from "@heroicons/vue/outline"
import { debounce, getNotFoundText } from "@/shared/utils/helpers"
import { useLandingPageGroupStore } from "@/stores/landing-page-group"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsLoading from "@/components/GgmsLoading.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsChip from "@/components/GgmsChip.vue"

interface Props {
    groupsSelectedState: boolean[]
    hasFilterGroups: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterLandingPageGroups',
  props: {
    groupsSelectedState: {},
    hasFilterGroups: { type: Boolean }
  },
  emits: ["onGroupSelect"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const landingPageGroupStore = useLandingPageGroupStore()

const localGroupsSelectedState = ref<boolean[]>(props.groupsSelectedState)

const groups = computed(() => landingPageGroupStore.tableState.data)

function createFilterGroup() {
    // get the selected tags ids which are selected in localGroupsSelectedState
    const selectedGroupsIds = localGroupsSelectedState.value
        .map((selected, index) => (selected ? groups.value[index]._id : null))
        .filter((id) => id !== null)

    emit("onGroupSelect", selectedGroupsIds)
}

onUnmounted(() => {
    landingPageGroupStore.tableState.search = ""
})

watch(
    () => landingPageGroupStore.tableState.search,
    debounce(() => {
        if (props.hasFilterGroups) {
            // this is to prevent the search from being triggered when the modal is closed
            return
        }
        landingPageGroupStore.tableState.currentPage = 0
        landingPageGroupStore.getAll()
    }, 250)
)

watch(
    () => localGroupsSelectedState.value,
    () => {
        createFilterGroup()
    },
    { deep: true }
)

watch(
    () => props.groupsSelectedState,
    () => {
        localGroupsSelectedState.value = props.groupsSelectedState
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GgmsInput, {
      modelValue: _unref(landingPageGroupStore).tableState.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(landingPageGroupStore).tableState.search) = $event)),
      placeholder: "Search values",
      iconStart: _unref(SearchIcon)
    }, null, 8, ["modelValue", "iconStart"]),
    _createElementVNode("div", _hoisted_1, [
      (_unref(landingPageGroupStore).tableState.isLoading)
        ? (_openBlock(), _createBlock(GgmsLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group._id,
                class: "flex items-center mb-5 last:mb-0"
              }, [
                _createVNode(GgmsCheckBox, {
                  modelValue: localGroupsSelectedState.value[i],
                  "onUpdate:modelValue": ($event: any) => ((localGroupsSelectedState.value[i]) = $event),
                  indeterminate: _ctx.groupsSelectedState[i] === null
                }, {
                  default: _withCtx(() => [
                    _createVNode(GgmsChip, {
                      bgColor: group.backgroundColor,
                      textColor: group.foregroundColor,
                      isRemovable: false,
                      class: "ml-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(group.displayName), 1)
                      ]),
                      _: 2
                    }, 1032, ["bgColor", "textColor"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "indeterminate"])
              ]))
            }), 128)),
            (!groups.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(getNotFoundText)("groups", _unref(landingPageGroupStore).tableState.search)), 1))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ], 64))
}
}

})